import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody,CModalFooter,CFormLabel,CFormSelect,CFormInput, CFormText, CFormCheck } from "@coreui/react";
import React from "react";
import { useState, useRef } from "react";
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import SaveDiagnosisData from "../../services/general/saveDiagnosisData.api";
import DeleteDiagnosis from "../../services/general/deleteDiagnosis.api";
import { Button } from "antd";
import axios from "axios";
import { useEffect } from "react";
import GetKeywords from "../../services/general/getKeywords.api";

const Keywords = () => {
  const deleteDiagnosis = async (e) => {
    await GetKeywords("DELETE",e.Keyword)
    alert("Keyword Deleted")
    await getData()

  }
    const buttonList = [{Name:'Delete', FunctionName:deleteDiagnosis}]
    const [diagnosisData, setDiagnosisData] = useState("")
     const [loading, setLoading] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)

    const diagnosisName = useRef("")
    const aliasName = useRef("")

    const title = useRef("")

    const handleonClick = (e) => {
        setModalVisible(e=>!e)
    }

    const saveDiagnosis = async () => {
      // SaveDiagnosisData()
      setLoading(true)
      try{
        let name = diagnosisName.current?.value
        //let alias = aliasName.current?.value
        let temp = await GetKeywords("INSERT",name)
        let a = await getData()
      } catch(e) {

      }
      
      setLoading(false)

      setModalVisible(false)

    }

    const getData = async () => {
      let a =  await GetKeywords("SELECT","")
      let data = JSON.parse(a.d)
      setDiagnosisData(a.d)
    }

    useEffect(()=>{
      let a  = getData()
    },[])

return (
    <>
    <CCard className="m-2" >
        <CCardBody>
        
    <CButton className="m-2" variant="outline" onClick={handleonClick}>
           +  Add Keyword
    </CButton>
        </CCardBody>
    </CCard>
    
    <CustomAgGrid rowClickedFn={deleteDiagnosis}  callFrom="Diagnosis" options={diagnosisData} btnList={buttonList} >

    </CustomAgGrid>
    
    <CModal

  size="md"
  visible={modalVisible}
  onClose={() => setModalVisible(false)}
  
>
  <CModalHeader onClose={() => setModalVisible(false)}>
    <CModalTitle>Add Keyword</CModalTitle>
  </CModalHeader>
  <CModalBody>
  <div className="mb-3">
    <CFormLabel >Name</CFormLabel>
    <CFormInput ref={diagnosisName}   />
    
  </div>
  {/* <div className="mb-3">
    <CFormLabel htmlFor="exampleInputPassword1">Alias</CFormLabel>
    <CFormInput ref={aliasName}   />
    <CFormText id="emailHelp">For Internal Use</CFormText>
  </div> */}

 
  </CModalBody>
  <CModalFooter>
    <CButton color="secondary" onClick={() => setModalVisible(false)}>Close</CButton>
    <Button type="primary" loading={loading} onClick={()=>saveDiagnosis()}>Save Changes</Button>
  </CModalFooter>
</CModal>
    
    
    
    </>
)
}


const AddButton = () => {
    return (
        <>
        <CButton style={{marginLeft:"10px"}} variant="outline" color="success">
            ADD +
        </CButton>
        </>
    )
}


export default Keywords